import { NgModule, OnInit } from '@angular/core';
import { ActivatedRoute, ActivationStart, Router, RouterModule, Routes } from '@angular/router';

import { HeaderService, HeaderType } from './services/header-service';
import { ScheduleAppointmentService } from './modules/schedule-appointment/services/schedule-appointment.service';
import { StaffScheduleDetailsComponent } from './modules/schedule-appointment/components/meeting-details/staff-schedule-details/staff-schedule-details.component';
import { DatePipe } from '@angular/common';

const routes: Routes = [
	{
		path: 'schedule',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/schedule-appointment.component.module').then((m) => m.ScheduleAppointmentModule),
	},
	{
		path: 'schedule/:userGUID',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/schedule-appointment.component.module').then((m) => m.ScheduleAppointmentModule),
	},
	{
		path: 'schedule/service/:serviceGUID',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/schedule-appointment.component.module').then((m) => m.ScheduleAppointmentModule),
	},
	{
		path: 'appointment',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/manage-appointment.component.module').then((m) => m.ManageAppointmentModule),
	},
	{
		path: 'appointment/:customerAppointmentGUID',
		data: { headerType: HeaderType.logoOnly },
		loadChildren: () => import('./modules/schedule-appointment/manage-appointment.component.module').then((m) => m.ManageAppointmentModule),
	},
	{ path: '**', redirectTo: 'https://www.trb.bank', data: { headerType: HeaderType.logoOnly } },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			onSameUrlNavigation: 'reload',
		}),
	],
	exports: [RouterModule],
	providers: [
		ScheduleAppointmentService,
		//VerficationService, AuthGuard, UserValidationGuard
	],
})
export class AppRoutingModule implements OnInit {
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public headerService: HeaderService
	) {
		// this.router.routeReuseStrategy.shouldReuseRoute = () => {
		//   return false;
		// };
		this.router.events.subscribe((event) => {
			if (event instanceof ActivationStart) {
				const data = event.snapshot.data;
				if (data?.headerType) {
					this.headerService.headerType = data.headerType;
				}
				this.headerService.headerText = data?.headerText;
			}
		});
		// this.activatedRoute.data.subscribe(data => {
		//   console.log(data);
		//       if(data?.headerType){
		//         this.headerService.headerType = data.headerType;
		//       }
		//       this.headerService.headerText = data?.headerText;
		//   })
	}

	ngOnInit() {}
}
